<template>
  <div class="pay_box">
    <common-title title="支付方式"></common-title>
    <div class="pay_list_box">
      <div
        class="pay_list_item"
        v-for="(item, index) in payList"
        :key="index"
        @click="selectItem(index)"
      >
        <div class="pay_left">
          <img class="pay_icon" :src="item.img" />
          <div class="pay_name">{{ item.name }}</div>
        </div>
        <img
          v-if="selectedPay == index"
          class="right_img"
          src="../assets/order/selected.png"
        />
        <img v-else class="right_img" src="../assets/order/unselected.png" />
      </div>
    </div>
  </div>
</template>

<script>
import commonTitle from "./common_title.vue";
export default {
  name: "pay",
  props: {},
  components: {
    commonTitle,
  },
  data() {
    return {
      payList: [
        { name: "支付宝支付", img: require("../assets/order/alipay.png") },
        { name: "微信支付", img: require("../assets/order/wechat.png") },
        { name: "授权支付", img: require("../assets/order/shouxin_pay.png") },
      ],
      selectedPay: 0,
    };
  },
  methods: {
    selectItem(index) {
      this.selectedPay = index;
      this.$emit("selectPayType", index);
    },
  },
};
</script>

<style lang="scss" scoped>
.pay_box {
  background-color: #ffffff;
  margin-left: vw(20);
  margin-right: vw(20);
  margin-top: vw(20);
  border-radius: vw(12);
  padding-bottom: vw(10);
  .pay_list_box {
    margin-top: vw(10);
    margin-left: vw(30);
    margin-right: vw(30);
    .pay_list_item {
      padding-top: vw(20);
      padding-bottom: vw(20);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .pay_left {
        display: flex;
        flex-direction: row;
        align-items: center;
        .pay_icon {
          width: vw(56);
          height: vw(56);
        }
        .pay_name {
          margin-left: vw(26);
          color: #333333;
          font-size: vw(30);
        }
      }
      .right_img {
        width: vw(32);
        height: vw(32);
      }
    }
  }
}
</style>
